import { DocumentReviewModel } from './document-review.model';

export interface PoeInformationSurvey {
  requestDetailId?: number;
  poecompletionDate?: string;
  pOEDocumentSubmittedDate?: string;
  customerPOESurveyDate?: string;
  partnerPOESurveyDate?: string;
  poeStatusId?: number;
  poeStatusName?: string;
  partnerPOESurveyStatusId: number;
  partnerPOESurveyStatus?: string;
  customerPOESurveyStatusId: number;
  customerPOESurveyStatus?: string;
  pOEDOCstatusId: number;
  pOEDOCstatus?: string;
  lastUserAlias?: string;
  lastUpdateDate?: Date;
  poeInvoiceStatusID?: number;
  poeInvoiceStatusName: string;
}

export class UpdatePOEInformationRequest {
  requestDetailId?: number;
  poecompletionDate?: string;
  pOEDocumentSubmittedDate?: string;
  poeStatusId?: number;
  poeStatusName?: string;
  lastUserAlias?: string;
  customerSurvey?: UpdatePOEInformationRequestSurvey =
    new UpdatePOEInformationRequestSurvey();
  documents?: UpdatePOEInformationRequestDocument[] = [];
  documentsRejectionInfo?: DocumentReviewModel[] = [];
}

export class UpdatePOEInformationRequestSurvey {
  type!: string;
  surveyId?: number;
  surveyStatusId?: number;
  surveyStatusName?: string;
  surveyDate?: string;
  requestDetailId!: number;
}

export interface ConstOptions {
  documentId?: number;
  documentTypeId?: number;
  documentStatusId?: number;
  documentStatusName?: string;
  isInvoiceDocument?: boolean;
}

export class UpdatePOEInformationRequestDocument {
  constructor(options: ConstOptions) {
    this.documentId = options.documentId;
    this.documentStatusName = options.documentStatusName;
    this.documentStatusId = options.documentStatusId;
    this.isInvoiceDocument = options.isInvoiceDocument;
    this.documentTypeId = options.documentTypeId;
  }

  documentId?: number;
  documentTypeId?: number;
  documentStatusId?: number;
  documentStatusName?: string;
  isInvoiceDocument?: boolean;
}

export class UpdateAdvisorIncentivesPOEInformationRequest {
  requestDetailId?: number;
  poecompletionDate?: string;
  pOEDocumentSubmittedDate?: string;
  poeStatusId?: number;
  poeStatusName?: string;
  lastUserAlias?: string;
  documents?: UpdatePOEInformationRequestDocument[] = [];
  documentsRejectionInfo?: DocumentReviewModel[] = [];
}
